function ContactPreview() {
  return (
    <section className="section scroll-reveal" id="contact">
      <div className="container contact-box">
        <div>
          <p className="section-tag">Contact</p>
          <h2>Let’s connect</h2>
          <p className="contact-text">
            I’m always interested in opportunities to learn, build, and work on
            meaningful software projects.
          </p>
        </div>

        <div className="contact-actions">
          <a href="mailto:dylantomlinson44@gmail.com" className="btn btn-primary magnetic">
            Email Me
          </a>
          <a
            href="https://www.linkedin.com/in/tomlinsond"
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary magnetic"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </section>
  );
}

export default ContactPreview;